import { render, staticRenderFns } from "./Jeremia.vue?vue&type=template&id=b95a64f0&scoped=true&"
import script from "./Jeremia.vue?vue&type=script&lang=js&"
export * from "./Jeremia.vue?vue&type=script&lang=js&"
import style0 from "./Jeremia.vue?vue&type=style&index=0&id=b95a64f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95a64f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VRow})
